export enum ELocationActionTypes {
  SET_LOCATION = 'location/setLocation',
}
